import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './vaccination.css';
import Right from '../../right/Right';
import Service from '../../service/Service';
const service = new Service();
class ViewChart extends Component {
    constructor(props) {
        super(props);
        let window_width = 1024;
       
        this.state = {
            window_width: window_width
        }
    }
    
    componentDidMount() {
        this.setState({window_width : window.innerWidth});
    }
    
    render(){
        var windowWidth = this.state.window_width;
        
        return (
            <main className="main-container week-by-week-cont vaccine_main_cont">
                <Helmet
                    title="Sample Chart - Vaccination & Baby Growth Tracker"
                    meta={[
                        { "name": "description", "content": "Check & track your baby`s age/gender wise vaccination status, height, weight & overall growth and maintain a digital record at FirstCry Parenting" },
                        {
                            "name" : "keywords", "content" : "fetal movement tracker, baby kicks counter, fetal monitor"
                        },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                         <span><Link to={service.getRedirectUrl("/tools/child-vaccination-growth-tracker/")} className="R11_9e">Child Vaccine &amp; Baby Growth Tracker</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Chart</span>
                    </div>
                </div>

                <div className="fetalvideo-head vaccination-head">
                    {
                        (windowWidth < 767) ? 
                        (<div className="mobile_listing">
                            <Link to={service.getRedirectUrl(`/tools`)} title=""><span className="icon" data-icon-font="s"></span></Link>
                        
                            <h1 className="M15_pink">Sample Chart | Vaccination</h1>
                        </div>) :
                        (<div className="">
                            <h1 className="B24_00">Sample Chart | Vaccination</h1>
                        </div>)
                    }
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                    <div class="chart_wrapper">
                        <img src="http://cdn.fcglcdn.com/brainbees/apps/image/10-growth-chart-image.png" alt="" />
                    </div>
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}
export default ViewChart;



// WEBPACK FOOTER //
// src/shared/tools/vaccination/viewchart.js